// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__1UjZC","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__3nZ89"};